import { localStorageService } from './../../../services/localStorage/localStorage.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    moduleId: module.id,
    selector: 'signup',
    templateUrl: 'signup.component.html',
    styleUrls: ['signup.component.scss']
})
export class SignupComponent {
    customer: any = {
        lastname: "",
        email: "",
        phone: "",
        pdv: "",
        password: "",
        confirmePassword: "",
    }
    loader: boolean = false;
    ourApp = false;
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private pdvService: PdvService,
        private router: Router,
        private localStorage:localStorageService,
        private orderService : OrdersService
    ) {
        this.customer.pdv = this.pdvService.idPdv;
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
    }

    signup() {
        this.loader = true;
        if (this.customer.lastname.trim() == '' || this.customer.email.trim() == '' || this.customer.phone.trim() == '' || this.customer.password.trim() == '' || this.customer.confirmePassword.trim() == '') {
            this.toastr.error('Merci de remplir tous les champs', 'Attention !');
            this.loader = false;
        } else {
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.customer.email))) {
                this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
                this.loader = false;
            } else {
                if (!this.customer.phone.match(/^\d{10}$/)) {
                    this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
                    this.loader = false;
                } else {
                    if (this.customer.password.trim().length < 8) {
                        this.toastr.error('mot de passe invalide minimum 8 caractères ', 'Attention !');
                        this.loader = false;
                    } else {
                        if (this.customer.password !== this.customer.confirmePassword) {
                            this.toastr.error('les mots de passe saisis ne sont pas identiques', 'Attention !');
                            this.loader = false;
                        } else {
                            this.webSiteUsersService.addCustomer(this.customer).subscribe(
                                (data: any) => {
                                    this.localStorage.setItem({key:'token', value: data.token});
                                    this.webSiteUsersService.listener.next(true);
                                        this.router.navigate(['/']);
                                }, (err: any) => {
                                    if (err.status == 409) {
                                        this.toastr.error('Ce compte existe déja', 'Attention !');
                                        this.loader = false;
                                    }
                                }
                            )
                        }
                    }
                }
            }
        }
    }
    
}
